module.exports = __webpack_public_path__ + "assets/img/zsj.a1c61c02.jpg";